<template>
<!-- background-repeat: no-repeat;background-size: cover; -->
<div class="">
    <!-- <div class="container-fluid">
        <div class="row login-content-section">
            <div class="col-sm-6 login-left-wrap">
                <div class="logo"><img src="../assets/img/LTBI.png" /></div>
                <h3>Welcome to <span>LTBI PROJECT</span></h3>
                <div class="login-left-bottom">
                    <div class="login-bottom-left">
                        <span>&copy; 2017</span>
                    </div>
                    <div class="login-bottom-right">
                        <ul>
                            <li><a href="#">About</a></li>
                            <li><a href="#">Terms</a></li>
                            <li><a href="#">Privacy</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 login-right-wrap">
                <div class="login-wrapper">
                    <h3><span>Login</span> to your account to manage all the services and explore our tools.</h3>
                     <ValidationObserver tag="div" ref="loginForm" @submit.prevent="getLoginDetails">
                         <form>
                            <div class="form-group">
                                <div class="input-group">
                                    <ValidationProvider tag="div" name="username" rules="required" v-slot="{ errors }">
                                        <input type="text" class="form-control" placeholder="Email" name="username" v-model="username" id="username" required autofocus />
                                        <div class="text-danger">{{ errors[0] }}</div>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="input-group">
                                    <ValidationProvider tag="div" name="Password" rules="required" v-slot="{ errors }">
                                        <input type="Password" class="form-control" placeholder="Password" name="password" v-model="password" id="password" required />
                                        <div class="text-danger">{{ errors[0] }}</div>
                                    </ValidationProvider> 
                                </div>
                            </div>
                         </form>
                     </ValidationObserver>
                    <br />

                    <a class="btn login-btn" @click="getLoginDetails"><span class="glyphicon glyphicon-off"></span> Proceed</a>
                    <br />
                </div>
            </div>
        </div>
    </div>
    <b-modal size="md" id="modal-incorrect-password" hide-footer>
        <template v-slot:modal-title> LTBI Generic </template>
        <div class="modal-body">
            {{message}}
        </div>
    </b-modal> -->
    <header>
        <nav class="navbar  navbar-fixed-top login_navbar">
            <div class="container">
                <div class="navbar-header">
                    <!-- <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#myNavbar">
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                    </button> -->
                    <a class="navbar-brand" href="#">
                        <img src="../assets/img/end_tb_logo.png" class="">
                        <span>Dashboard</span>
                    </a>
                </div>
                <!-- <div class="collapse navbar-collapse" id="myNavbar">
                    <ul class="nav navbar-nav">
                        <li class="active"><a href="#">Home</a></li>
                        <li class="dropdown">
                            <a class="dropdown-toggle" data-toggle="dropdown" href="#">Page 1 <span class="caret"></span></a>
                            <ul class="dropdown-menu">
                                <li><a href="#">Page 1-1</a></li>
                                <li><a href="#">Page 1-2</a></li>
                                <li><a href="#">Page 1-3</a></li>
                            </ul>
                        </li>
                        <li><a href="#">Page 2</a></li>
                        <li><a href="#">Page 3</a></li>
                    </ul>
                    <ul class="nav navbar-nav navbar-right">
                        <li><a href="#"><span class="glyphicon glyphicon-user"></span> Sign Up</a></li>
                        <li><a href="#"><span class="glyphicon glyphicon-log-in"></span> Login</a></li>
                    </ul>
                </div> -->
            </div>
        </nav>
    </header>
    <div class="container-fluid mainContent">
        <div class="row w-100">
            <div class="col-md-8">
                <div class="descmessage">
                    The comprehensive dashboard for Prevent TB initiative facilitates real-time monitoring of individual TB and LTBI clients. The innovative representation with interactive charts, maps, real-time alerts, and client line listing helps the program to leverage data for prompt action and effective policy.
                    <div class="row mt-4 no-gutters buttonsDesc">
                        <div class="col-md-2" style="margin-right: 10px;">
                            <button class="btn btn-default downloadBtn" v-b-modal.training-video> <i class="fab fa-youtube"></i> Training Video</button>
                        </div>
                        <div class="col-md-3">
                            <a target="_blank" href="https://uatltbi.duredemos.com/training_resources/LTBI_TrainingManual_Dashboard_V2.pdf" class="btn btn-default downloadBtn "> <i class="fas fa-book"></i> Training Manual</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="loginContainer">
                    <div class="card loginCard">
                        <div class="card-header">
                            <span>Login Form</span>
                        </div>
                        <div class="card-body">
                            <ValidationObserver tag="div" ref="loginForm" @submit.prevent="getLoginDetails">
                                <form>
                                    <div class="form-group">
                                        <label for="usr">Username</label>
                                        <div class="input-group">
                                            <span class="input-group-addon"><i class="far fa-user-circle"></i></span>
                                            <ValidationProvider class="w-75" tag="div" name="Username" rules="required" v-slot="{ errors }">
                                                <input id="email" type="text" class="form-control" v-model="username" name="email" placeholder="Enter your username">
                                                <div class="text-danger">{{ errors[0] }}</div>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="usr">Password</label>
                                        <div class="input-group">
                                            <span class="input-group-addon"><i class="fas fa-fingerprint"></i></span>
                                            <ValidationProvider class="w-75" tag="div" name="Password" rules="required" v-slot="{ errors }">
                                                <input id="password" type="password" class="form-control" v-model="password" name="password" placeholder="Enter your password">
                                                <div class="text-danger">{{ errors[0] }}</div>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <button type="submit" class="btn btn-default loginBtn">Log me in</button>
                                </form>
                            </ValidationObserver>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <footer class="footer">
        <div class="container">
            <div class="row flexRow">
                <div class="col-md-6">
                    Powered by
                    <img class="pl-1" src="../assets/img/durelogo.png">
                </div>
                <div class="col-md-6">
                    <div class="widthMaxContent ml-auto">Copyright &copy; 2020. All rights reserved</div>
                </div>
            </div>
        </div>
    </footer>
    <b-modal size="md" id="modal-incorrect-password" hide-footer>
        <template v-slot:modal-title> LTBI Generic </template>
        <div class="modal-body">
            {{message}}
        </div>
    </b-modal>
    <b-modal size="lg" id="training-video" hide-footer>
        <template v-slot:modal-title> Training Video </template>
        <div class="modal-body">
            <video width="100%" controls>
                <source src="https://uatltbi.duredemos.com/training_resources/Prvent_TB_Dashboard.mp4" type="video/mp4">
                Your browser does not support HTML5 video.
            </video>
        </div>
    </b-modal>
</div>
</template>

<style scoped>
.login_navbar {
    background: #E7E8EA;
    height: 100px;
}

.login_navbar .navbar-brand {
    height: 100px;
    padding: 0 15px;
    display: flex;
    align-items: center;

}

.login_navbar .navbar-brand img {
    height: 80px;
    width: auto;
}

.login_navbar .navbar-brand span {
    font-size: 24px;
    color: #4F4F4F;
    font-weight: 500;
    margin-left: 10px;
}

.mt-100px {
    margin-top: 100px;
}

.loginCard .input-group-addon {
    color: #218FCD;
    background: transparent;
    font-size: 24px;
    border: 0;
    padding: 0 10px;
}

.loginCard .form-group label {
    margin-left: 44px;
}

.loginCard .loginBtn {
    background: #218FCD;
    color: #fff;
    border-color: #218FCD;
    margin-left: 44px;
}

.downloadBtn,
.downloadBtn:hover,
.downloadBtn:focus,
.downloadBtn:active {
    background: #ffffff;
    color: #238cbb;
    border-color: #ffffff;
}

.loginCard {
    border: 5px solid #E7E8EA;
    border-radius: 4px;
    background: #fff;
}

.loginCard .card-header {
    height: 80px;
    display: flex;
    align-items: flex-end;
    border-bottom: 1px solid #E7E8EA;
}

.loginCard .card-header span {
    font-size: 20px;
    font-weight: 600;
    color: #4F4F4F;
    margin-left: 59px;
    line-height: 40px;
}

.loginCard .card-header span:after {
    content: '';
    height: 4px;
    width: 20px;
    display: block;
    background: #218FCD;
}

.loginCard .card-body {
    padding: 15px;
    box-sizing: border-box;

}

.loginCard .form-group {
    margin-bottom: 25px;
}

.mainContent {
    /* height: calc(100vh); */
    margin-top: 0px !important;
    min-height: calc(100vh - 40px) !important;
    background: url(../assets/img/loginpagebg.jpg) no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

.descmessage {
    font-size: 16px;
    color: #fff;
    font-weight: 500;
    margin-top: 30px;
    padding: 0 15px;
}
</style>

<script>
import axios from "axios"
import JQuery from 'jquery'
let $ = JQuery
import swal from 'sweetalert2';
import ApiServices from '../service/ApiServices';
export default {
    data() {
        return {
            username: '',
            password: '',
            message: '',
        }
    },
    mixins: [],
    methods: {
        checkUserName() {
            if(this.username == '1385728_pa@preventtb.org' || this.username == ('1385728_sa@preventtb.org'))
                this.getLoginDetails()
            else
                this.getNikshayLoginDetails()
            // this.getLoginDetails()
        },
        getLoginDetails() {
            var self = this
            this.$refs.loginForm.validate().then(res => {
                console.log(btoa(self.username + ':' + self.password))
                if (res) {
                    let loginData = {
                        "username": self.username,
                        "password": self.password,
                        "language": "en",
                    }
                    self.$root.isLoading = true
                    let instance = axios.create();
                    instance.defaults.headers.common['Authorization']  = 'Basic ' + btoa(self.username + ':' + self.password)
                    // instance.post( ApiServices.GetBaseUrl() + 'rtmpro/login', loginData)
                    instance.get( ApiServices.GetBaseUrl() + 'me?fields=:all,organisationUnits[id,name],userGroups[id],userCredentials[:all,!user,userRoles[id,name]')
                        .then(response => {
                            console.log(response);
                            response = response.data
                            if (response.id) {
                                instance.get(ApiServices.GetBaseUrl()+'organisationUnits/'+ response.organisationUnits[0].id).then(res => {
                                    response.programid = res.data.programs[0].id
                                    console.log(response)
                                    response.authparam = 'Basic ' + btoa(self.username + ':' + self.password)
                                    sessionStorage.userData = JSON.stringify(response);
                                    instance.get(ApiServices.GetBaseUrl() + 'dataStore/labeltranslation/labeltranslation').then(res => {
                                        sessionStorage.langLocal = JSON.stringify(res.data);
                                        for (let lang in res.data) {
                                            self.$i18n.setLocaleMessage(lang, res.data[lang])
                                        }
                                        instance.get(ApiServices.GetBaseUrl() + 'dataStore/disclaimer/disclaimer').then(response => {
                                            sessionStorage.disclaimerLocal = JSON.stringify(response.data.data);
                                        })
                                        // self.$i18n.setLocaleMessage(res)
                                        self.$router.push('/home')
                                    })
                                })
                                // self.$router.push('/home')
                            } else {
                                self.message = ''
                                self.message = response.message
                                self.$bvModal.show('modal-incorrect-password')
                            }
                            self.$root.isLoading = false
                        })
                        .catch(error => {
                            console.log(error);
                            self.$root.isLoading = false
                            swal.fire("Request Failed.");
                        })
                }
            })
        },
        // Code for SSO in Nikshay
        getNikshayLoginDetails() {
            var self = this
            this.$refs.loginForm.validate().then(res => {
                console.log(res)
                if (res) {
                    let loginData = {
                        "username": self.username,
                        "password": self.password,
                        "language": "en",
                    }
                    self.$root.isLoading = true
                    // ApiServices.RestPostCall('rtmpro/login', JSON.stringify(loginData), {
                    ApiServices.RestPostCall('ltbi/sso', JSON.stringify(loginData))
                        .then(response => {
                            console.log(response);
                            if (response.status == 'success') {
                                sessionStorage.userData = JSON.stringify(response);
                                const headers = {
                                    'Content-Type': 'application/json',
                                    'Authorization': response.authparam
                                }
                                setTimeout(function(){
                                    ApiServices.RestPostCall('ltbi/dashboard/config/get/dash/labeltranslation', {
                                    "programid": response.programid
                                }).then(res => {
                                    // console.log(res)
                                    sessionStorage.langLocal = JSON.stringify(res);
                                    for (let lang in res) {
                                        // console.log(lang, res[lang])
                                        self.$i18n.setLocaleMessage(lang, res[lang])
                                    }
                                    ApiServices.RestPostCall('ltbi/dashboard/config/get/disclaimer/translation', {
                                        "programid": response.programid
                                    }).then(response => {
                                        // console.log(res)
                                        sessionStorage.disclaimerLocal = JSON.stringify(response.data);
                                    })
                                    // self.$i18n.setLocaleMessage(res)
                                    self.$router.push('/home')
                                })
                                // var instance = axios.create();
                                // delete instance.defaults.headers.common["Authorization"];
                                // instance.post(ApiServices.GetBaseUrl() + 'ltbi/dashboard/config/get/dash/labeltranslation', {
                                //     "programid": response.programid
                                // }, {
                                //     headers: headers
                                // }).then(res => {
                                //     // console.log(res)
                                //     sessionStorage.langLocal = JSON.stringify(res);
                                //     for (let lang in res) {
                                //         // console.log(lang, res[lang])
                                //         self.$i18n.setLocaleMessage(lang, res[lang])
                                //     }
                                //     var instance2 = axios.create();
                                //     delete instance2.defaults.headers.common["Authorization"];
                                //     instance2.post(ApiServices.GetBaseUrl() + 'ltbi/dashboard/config/get/disclaimer/translation', {
                                //         "programid": response.programid
                                //     },{
                                //     headers: headers
                                // }).then(response => {
                                //         // console.log(res)
                                //         sessionStorage.disclaimerLocal = JSON.stringify(response.data);
                                //         self.$router.push('/home')
                                //     })
                                //     // self.$i18n.setLocaleMessage(res)
                                // })
                                },2000)
                            } else {
                                self.message = ''
                                self.message = response.message
                                self.$bvModal.show('modal-incorrect-password')
                            }
                            self.$root.isLoading = false
                        })
                        .catch(error => {
                            console.log(error);
                            self.$root.isLoading = false
                            swal.fire("Request Failed.");
                        })
                }
            })
        }
    },
    mounted() {
        // this.getLoginDetails();
    }
}
</script>
